import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

import { CategoriesApi, type CategorySchema } from 'openapi'

export const useParentCategories = (categoryId: number | undefined | null): CategorySchema[] => {
  const { data: categories } = useCategoriesListQuery()
  if (!categoryId) return []
  if (!categories) return []

  const getCategoryById = (id: number | null | undefined) => categories!.find((cat) => cat.id === id)

  const parentCategories = []

  let category = getCategoryById(categoryId)
  while (category) {
    parentCategories.push(category)
    category = getCategoryById(category.parent_id)
  }

  parentCategories.reverse()
  return parentCategories
}

export function useCategoryQuery(id: number) {
  return useQuery({ queryKey: ['retrieveCategory', id], queryFn: () => CategoriesApi.get({ id: id }) })
}

export const useCategoriesListQuery = (
  options: Omit<UseQueryOptions<CategorySchema[]>, 'queryKey' | 'queryFn'> = {},
) => {
  return useQuery<CategorySchema[]>({ queryKey: ['listCategories'], queryFn: () => CategoriesApi.list(), ...options })
}

export const useCategory = (id?: number): [CategorySchema | undefined, boolean] => {
  // usiig useCategoriesListQuery because it's cached
  const { data: categories, isLoading } = useCategoriesListQuery()
  if (!id) return [undefined, false]
  return [categories?.find((cat) => cat.id === id), isLoading]
}
